import { Col, Row } from 'antd'
import { GetServerSideProps, NextPage } from 'next'
import React, { useCallback, useState } from 'react'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { SEOHead } from '~/components/business/SEOHead'
import { Container } from '~/components/ui/Container'
import { Layout } from '~/layouts/default'
import { SingleCollection } from '~/components/business/SingleCollection'
import { GlobalRequest } from '~/components/global-requset'
import { GET_COLLECTION_LIST } from '~/graphqls/gqls'
import {
  ArtworkSeriesSortEnum,
  getCollectionList,
  getCollectionListVariables,
  getCollectionList_marketingModule_collectionList_edges_node,
} from '~/graphqls/types'
import { getGraphData, uniqueArray } from '~/utils'
import { PAGE_SIZE } from '~/configs'
import { MyEmpty } from '~/components/ui/MyEmpty'
import { InfiniteScroll } from '~/components/business/InfiniteScroll'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'

const Collections: NextPage<{
  hasNextPage: boolean
  collectionList: getCollectionList_marketingModule_collectionList_edges_node[]
}> = ({ hasNextPage: nextPage, collectionList }) => {
  const [loading, setLoading] = useState(false)
  const [hasNextPage, setHasNextPage] = useState(nextPage)
  const [collectionListData, setCollectionListData] = useState(collectionList)

  const getCollectionList = useImperativeQuery<
    getCollectionList,
    getCollectionListVariables
  >(GET_COLLECTION_LIST)

  const [pageInfo, setPageInfo] = useState({
    page: 1,
    pageSize: PAGE_SIZE,
  })

  const onScroll = useCallback(() => {
    setLoading(true)

    getCollectionList({
      offset: pageInfo.pageSize * pageInfo.page,
      first: pageInfo.pageSize,
      params: {
        sortField: ArtworkSeriesSortEnum.TRANSACTION_MONEY,
      },
    })
      .then(data => {
        setPageInfo(page => {
          return {
            pageSize: page.pageSize,
            page: page.page + 1,
          }
        })

        setHasNextPage(
          data?.data?.marketingModule?.collectionList?.pageInfo?.hasNextPage ||
            false
        )

        setCollectionListData(list => {
          return uniqueArray(
            list,
            getGraphData(
              data?.data?.marketingModule?.collectionList?.edges || []
            )
          )
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [pageInfo, getCollectionList])

  return (
    <Layout>
      <SEOHead title="精选合集" />
      <Container>
        <PageCrumbs title="精选合集" />
        {collectionListData.length ? (
          <>
            <Row gutter={32}>
              {collectionListData.map(item => (
                <Col span={6} key={item.id}>
                  <SingleCollection data={item} />
                </Col>
              ))}
            </Row>
            <InfiniteScroll
              onScroll={onScroll}
              hasNextPage={hasNextPage}
              loading={loading}
            />
          </>
        ) : (
          <MyEmpty />
        )}
      </Container>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)

  const collectionListRes = await client.query<
    getCollectionList,
    getCollectionListVariables
  >({
    query: GET_COLLECTION_LIST,
    variables: {
      first: PAGE_SIZE,
      offset: 0,
      params: {
        sortField: ArtworkSeriesSortEnum.TRANSACTION_MONEY,
      },
    },
    fetchPolicy: 'no-cache',
  })

  return {
    props: {
      initialState,
      collectionList: getGraphData(
        collectionListRes.data.marketingModule?.collectionList?.edges || []
      ),
      hasNextPage:
        collectionListRes.data.marketingModule?.collectionList?.pageInfo
          ?.hasNextPage || false,
    },
  }
}

export default Collections
